<template>
  <div class="flex flex-col items-start">
    <div class="md:text-center w-full">
      <p class="text-24 md:text-28 font-bold">Invite your team members</p>
      <p class="text-17">Two people makes a team.</p>
      <img v-if="image" class="rounded-6 h-115 max-w-full object-contain mt-30 mx-auto" :src="image" alt="image">
    </div>

    <div
      class="flex flex-col items-center w-full mt-40"
    >
      <!-- T E A M  M E M B E R S  L I S T -->
      <InputModule
        v-for="(teamMember, itemName, i) in teamMembersInputs"
        ref="teamMembersListRef"
        :key="`team-member-input-${i}`"
        v-model="teamMembersInputs[itemName]"
        :name="`teamMember${i}`"
        type="email"
        :label="`Team member email #${i + 1}`"
        placeholder="name@email.com"
        class="w-full mb-30 font-bold"
        input-classes="px-22 py-14"
        :error-message="errorMessages[itemName]"
        @clearErrorMessage="name => errorMessages[name] = null"
      />

      <!-- A D D  M O R E  F I E L D S  B T N -->
      <ButtonModule
        text="Add more fields"
        prefix="icon-add text-10"
        class="text-blue-new text-15 mb-30"
        @click.prevent="addTeamMember"
      />
    </div>

    <!-- I N V I T E  Y O U R  T E A M  B T N -->
    <ButtonModule
      text="Invite your team"
      class="w-full justify-center bg-blue-new text-white text-16 font-bold rounded-4 mb-30 py-20 px-46 ease-in-out hover:opacity-80"
      @click.prevent="invite"
    />

    <!-- S K I P  T H I S  S T E P  B T N -->
    <div class="flex justify-center items-center border-t border-hover w-full pt-20">
      <span class="text-13">I will do this later.</span>
      <ButtonModule
        text="Skip this for now"
        class="text-blue-new text-13"
        @click.prevent="skipForNow"
      />
    </div>
  </div>
</template>

<script>
import { defineComponent, reactive, ref } from 'vue'
import { useStore } from 'vuex'

import InputModule from '@/components/shared/form-controls/InputModule'
import ButtonModule from '@/components/shared/form-controls/ButtonModule'

import { emailValidation } from '@/helpers'
import { useRouter } from 'vue-router'
import { teamsService } from '@/services'

export default defineComponent({
  name: 'InviteTeamMembers',

  components: { InputModule, ButtonModule },

  props: {
    teamId: Number,
    companyName: String,
    image: String
  },

  setup (props) {
    const { commit } = useStore()
    const router = useRouter()
    /* DATA */
    const teamMembersListRef = ref('')

    const errorMessages = reactive({
      teamMember0: null,
      teamMember1: null
    })

    const teamMembersInputs = reactive({
      teamMember0: '',
      teamMember1: ''
    })

    /* METHODS */
    const addTeamMember = () => {
      const teamMembersInputsLength = Object.keys(teamMembersInputs).length

      teamMembersInputs[`teamMember${teamMembersInputsLength}`] = ''
      errorMessages[`teamMember${teamMembersInputsLength}`] = null
    }

    function skipForNow () {
      commit('showWelcomeModal', true)
      router.push({ name: 'TeamBooks', params: { team: props.companyName } })
    }

    function invite () {
      const invitedUsers = []
      Object.entries(teamMembersInputs).forEach(([key, value]) => {
        if (value === '') return

        if (!errorMessages[key]) {
          const error = emailValidation(teamMembersInputs[key])

          if (!error) {
            invitedUsers.push(value)
          } else {
            errorMessages[key] = error
          }
        }
      })

      if (Object.values(errorMessages).every(i => !i)) {
        commit('loading', true)
        setTimeout(() => {
          teamsService.inviteMembers({ emails: invitedUsers, teamId: props.teamId })
            .then(() => {
              commit('showWelcomeModal', true)
              router.push({ name: 'TeamBooks', params: { team: props.companyName } })
            })
        }, 2000)
      }
    }

    return {
      // refs
      teamMembersListRef,

      // reactives
      teamMembersInputs,
      errorMessages,

      // functions,
      addTeamMember,
      invite,
      skipForNow
    }
  }
})
</script>

<style scoped>

</style>
